import app from 'flarum/app';

app.initializers.add('hyperactiveknight/flarum-ext-bbcodeschema', () => {
  console.log('Hello, forum!');
});
